import PropTypes from 'prop-types';
import { Card, vars } from '@etg/wings';
import { css, etiColors } from '@eti/styles';
import { CarrierLogo, Icon } from '@eti/components';
import { useDateFormat, useDirection, useSiteContext } from '@eti/providers';
import { date, duration as durationUtil } from '@eti/utils';
import { RegionNew } from '@eti/types';

const originDestinationStyles = css`
  display: flex;
  flex-direction: row;
  font-size: 0.75rem;
  justify-content: flex-start;
  width: 100%;
`;

const cityNameStyles = css`
  color: ${etiColors.grayScale[10]};
  font-size: 0.625rem;
  line-height: 17px;
`;

const arrowStyles = css`
  line-height: 20px;
  margin: 0 10px;

  [dir='rtl'] & {
    transform: rotateY(180deg);
  }
`;

const departureArrivalDatesStyles = css`
  font-size: 0.75rem;
  line-height: 17px;
`;

const durationStyles = css`
  color: ${etiColors.grayScale[10]};
  font-size: 0.75rem;
  line-height: 17px;
`;

const carrierStyles = css`
  display: flex;
  flex-direction: row;
  margin-top: 2px;
`;

const carrierLogoStyles = css`
  height: 16px;
  line-height: 17px;
  margin-right: 6px;
  width: 16px;

  [dir='rtl'] & {
    margin-left: 6px;
    margin-right: 0;
  }
`;

const cardStyles = css`
  border: 1px solid ${vars.colors.divider};
`;

const carrierNameStyles = css`
  color: ${etiColors.grayScale[10]};
  font-size: 0.625rem;
  line-height: 17px;
  margin-right: 5px;

  [dir='rtl'] & {
    margin-left: 5px;
    margin-right: 0;
  }
`;

const ReviewTripDetailsSegment = ({
  arrivedAt,
  boundNumber,
  departuredAt,
  destination,
  duration,
  index,
  marketingCarrier,
  origin,
}) => {
  const { direction } = useDirection();
  const { dayTime } = useDateFormat();
  const { language, timeFormat } = useSiteContext();

  return (
    <Card
      className={cardStyles}
      data-testid={`travelerDetails-reviewModal-flightInformation-bound-${boundNumber}-segment-${
        index + 1
      }`}
    >
      <div className={originDestinationStyles}>
        <div>
          <strong> {origin.code} </strong>
          {origin.name}
          <div className={cityNameStyles}> {origin.cityName} </div>
        </div>
        <div className={arrowStyles}>
          <Icon
            color={etiColors.grayScale[10]}
            data-testid="travelerDetails-reviewModal-flightInformation-tripDetails-destinationArrow"
            direction={direction}
            id="arrow-right"
            size="0.75rem"
          />
        </div>
        <div>
          <strong> {destination.code} </strong>
          {destination.name}
          <div className={cityNameStyles}> {destination.cityName} </div>
        </div>
      </div>
      <div className={departureArrivalDatesStyles}>
        <strong>
          {date.format(departuredAt, dayTime)} - {date.format(arrivedAt, dayTime)}
        </strong>
      </div>
      <div className={durationStyles}>
        {' '}
        {durationUtil.getDuration(duration, language.code, timeFormat)}{' '}
      </div>
      <div className={carrierStyles}>
        <CarrierLogo
          className={carrierLogoStyles}
          id={marketingCarrier.code || ''}
          imageAlt={marketingCarrier.name}
        />
        <div className={carrierNameStyles}>{marketingCarrier.name}</div>
      </div>
    </Card>
  );
};

ReviewTripDetailsSegment.propTypes = {
  arrivedAt: PropTypes.string,
  boundNumber: PropTypes.number,
  departuredAt: PropTypes.string,
  destination: RegionNew,
  duration: PropTypes.number,
  index: PropTypes.number,
  marketingCarrier: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  }),
  origin: RegionNew,
};

export default ReviewTripDetailsSegment;
